// Clipboard-with-health-cross illustration extracted from the Figma health check modal SVG.
// stroke="currentColor" so the icon adapts to light and dark mode.
export function HealthCheckIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M22.8361 17.1797C21.9209 17.6565 19.5145 16.5921 19.4185 17.9125C19.3033 19.4869 19.7065 31.1669 19.7513 39.3525C19.7961 47.5381 18.5225 49.2533 18.5609 49.6309C18.6441 50.4565 43.8409 51.1285 43.8409 51.1285C43.8409 51.1285 45.0249 42.4757 45.1273 34.3797C45.2297 26.4309 45.1721 18.8533 45.1657 18.1621C45.1529 17.3256 40.6409 17.6821 40.6409 17.6821"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
            <path
                d="M29.1527 14.8021C29.1527 14.8021 24.4487 14.5846 23.8407 14.7945C22.7911 15.1561 22.3751 19.7301 24.0199 19.9221C25.8311 20.1333 32.5767 20.0757 36.6471 20.1525C36.6471 20.1525 40.0839 20.2933 40.3207 19.9669C41.2743 18.6357 41.1591 15.8447 40.2183 15.2617C39.4887 14.8073 35.7319 14.9801 35.7319 14.9801"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
            <path
                d="M29.2937 14.2683C29.2489 10.8897 35.5145 10.1608 35.6105 14.7425C35.6745 18.0603 29.3513 18.5147 29.2937 14.2683Z"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
            <path
                d="M27.4059 27.4222C27.4059 27.4222 30.6316 27.627 30.6828 27.1726C30.734 26.7182 30.3371 23.7422 30.9771 23.6846C32.1483 23.5758 34.2347 23.2046 34.3051 24.2926C34.3627 25.1118 34.0555 27.115 34.4907 27.1022C34.9195 27.0894 37.6459 26.9806 37.6011 27.6206C37.5627 28.2606 38.1067 29.7646 37.3259 30.3854C36.8459 30.7694 34.2731 30.1422 34.3243 30.7886C34.3755 31.435 34.7211 33.8606 34.1579 33.9566C33.6011 34.0462 30.7339 34.1678 30.6443 33.6558C30.4075 32.4206 30.9387 30.8782 30.3051 30.7758C29.6779 30.6798 27.0731 31.147 27.0987 30.5966C27.1307 30.0462 26.8235 27.4478 27.4059 27.4222Z"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
            <path
                d="M26.1768 37.8247C26.356 37.6519 31.8792 38.0487 32.2504 38.0743C33.8312 38.1831 36.2375 38.3111 38.7783 38.1959"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.2539 42.1875C28.1547 42.3091 33.5499 42.482 36.4875 42.5652"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.5161 46.1445C28.9609 46.2277 32.8009 46.2981 35.2393 46.3749"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.6602 23.9557C30.3626 22.5861 31.4378 27.2261 31.169 27.3605C30.2154 27.8405 28.7626 27.4566 27.9178 27.911C27.585 28.0902 27.5338 29.8885 27.7898 30.0037C28.545 30.3493 30.561 29.8566 31.0154 30.5094C31.3546 31.0022 30.8362 32.8837 31.3418 33.1653C31.8474 33.4405 32.4298 33.3765 32.9482 33.3445C34.7082 33.2293 32.8586 31.0277 34.0554 30.2021C34.1002 30.1701 34.1578 30.1445 34.209 30.1189C34.8938 29.7733 35.8858 30.3046 36.513 29.8694C37.281 29.3382 37.057 27.9621 36.2698 27.6805C35.713 27.4821 34.3562 27.8405 33.921 27.4181C33.3002 26.8165 34.2858 25.2165 33.8058 24.5253C33.6138 24.2501 32.9674 24.1413 32.6602 23.9557Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.2778 49.8666C19.2778 49.8666 21.0763 50.1355 26.1963 50.5515C31.3419 50.9739 43.5595 52.3498 44.2635 51.9338C44.9163 51.5498 45.7546 41.4507 45.761 38.5515C45.7674 35.9083 45.8443 24.4843 45.7931 21.6171C45.7355 18.7435 45.0954 17.9883 45.0954 17.9883"
                stroke="currentColor"
                strokeWidth="1.28"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
        </svg>
    );
}
